module.exports = __webpack_public_path__ + "img/popbg2.7d4bc486.png";